import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { invokeTimestreamSuggestions, invokeTimestreamSearch } from './actions/searchActions';
import { assetSearchCompleted } from 'owa-timestream-asset-search';

export type { SearchResultItem } from 'owa-timestream-asset-search';

export { default as getSuggestionQueryString } from './selectors/getSuggestionQueryString';
export { default as getSearchQueryString } from './selectors/getSearchQueryString';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TimestreamSearchOrchestration" */ './lazyIndex')
);

// Actions are public so external packages can listen to them
export {
    invokeTimestreamSuggestions,
    invokeTimestreamSearch,
    timestreamSearchCompleted,
} from './actions/searchActions';

// Orchestrators are lazy so that we don't pull in code for them until relevant action is called
registerLazyOrchestrator(
    invokeTimestreamSearch,
    lazyModule,
    m => m.invokeTimestreamSearchOrchestrator
);
registerLazyOrchestrator(
    invokeTimestreamSuggestions,
    lazyModule,
    m => m.invokeTimestreamSuggestionsOrchestrator
);
registerLazyOrchestrator(assetSearchCompleted, lazyModule, m => m.assetSearchCompletedOrchestrator);
